import { json1ParseCatch } from "../../sharedF/jsonF.mts";
export const getFePub = () => {
    const envJsonStr = process.env.NEXT_PUBLIC_JSON ?? '';
    return (json1ParseCatch(envJsonStr) || {});
};
